import { Formatters, NumberFormat } from '@billy/design-system'

interface NumberFormatterParams {
  locale: string
  number?: number
  withDigits?: boolean
}

export const formatReportNumber = ({ locale, number, withDigits = true }: NumberFormatterParams) =>
  NumberFormat.getFormattedNumber(number || 0, Formatters.getFormatLocale(locale), {
    ...(withDigits && {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  })
